// extracted by mini-css-extract-plugin
export default {"listItemChild":"SecondaryNavList_listItemChild__cXDF0"};